import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon, getUtility, ExpandedTooltip, InputWithIcon, SelectMenu } from '@livable/saas-react-components';
import HelpCenterButton from 'src/components/shared/HelpCenterButton';
import { Button, Typography, ToggleButtonGroup, ToggleButton, Grid, TextField, MenuItem } from '@mui/material';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { toJS } from 'mobx';
import { ALLOCATION_METHOD } from 'src/constants/utilities';
export default function AllocationMethodModal(_ref) {
  let setUtilityAllocationMethod = _ref.setUtilityAllocationMethod,
    utility = _ref.utility,
    billingMethod = _ref.billingMethod,
    disabledTrigger = _ref.disabledTrigger,
    onSaveAndClose = _ref.onSaveAndClose,
    isEdit = _ref.isEdit,
    setParentBuildingSquareFootageLocal = _ref.setParentBuildingSquareFootageLocal,
    propertySqFootage = _ref.propertySqFootage;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const isRubsBilling = store.account.featureFlagsStore.getEnableSubmeterBilling && billingMethod === 'RUBS';
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  const _useState3 = useState(propertySqFootage),
    _useState4 = _slicedToArray(_useState3, 2),
    initSqFootage = _useState4[0],
    setInitSqFootage = _useState4[1];
  const _useState5 = useState(propertySqFootage),
    _useState6 = _slicedToArray(_useState5, 2),
    localBuildingSquareData = _useState6[0],
    setLocalBuildingSquareData = _useState6[1];
  const _useState7 = useState(utility.allocationMethod),
    _useState8 = _slicedToArray(_useState7, 2),
    initAllocationMethod = _useState8[0],
    setInitAllocationMethod = _useState8[1];
  const _useState9 = useState(utility.allocationMethod),
    _useState0 = _slicedToArray(_useState9, 2),
    allocationMethod = _useState0[0],
    setAllocationMethod = _useState0[1];
  const _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    unitOfMeasure = _useState10[0],
    setUnitOfMeasure = _useState10[1];
  const handleAllocationMethodChange = (e, value) => {
    if (value) setAllocationMethod(value);
  };
  const handleUnitOfMeasureChange = event => {
    if (event.target.value) setUnitOfMeasure(event.target.value);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getWarning = isProviderName => /*#__PURE__*/React.createElement("div", {
    className: classes.warning
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "warning",
    title: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white"
    }, t('add_new_property_flow.reminder')), isProviderName ? t('add_new_property_flow.enter_provider_name') : t('add_new_property_flow.enter_utility_name')),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    type: "warning",
    fontSize: isProviderName ? 'small' : '',
    state: "warning"
  }))));
  const modalTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement("span", null, getUtility(toJS(utility).name || toJS(utility).utilityTypeName).icon({
    pattern: 'gradient'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, getUtility(toJS(utility).name || toJS(utility).utilityTypeName).title, ' ', t('add_new_property_flow.configuration')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "/ ", t('add_new_property_flow.allocation_method_modal')));
  const modalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, utility.utilityProviderName);
  const BuildingSquareInternal = _ref2 => {
    let isBySquareFootage = _ref2.isBySquareFootage;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.property_square_footage'))), /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "Property square footage is required for allocation method '", isBySquareFootage ? 'Square footage' : '50%Occupancy/50%Square Footage', "'. Please fill in a field below.")), /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      rowSpacing: 24,
      columnSpacing: 10
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "building"
      })
    }, /*#__PURE__*/React.createElement(TextField, {
      label: t('general.square_ft'),
      variant: "outlined",
      fullWidth: true,
      autoFocus: true,
      type: "text",
      id: "buildingSquare",
      name: "buildingSquare",
      value: localBuildingSquareData,
      onKeyPress: event => {
        if (!/[0-9]/.test(event.key)) {
          event.preventDefault();
        }
      },
      onChange: event => {
        event.preventDefault();
        if (!/^[1-9][0-9]*$|^$/.test(event.target.value)) return;
        setLocalBuildingSquareData(event.target.value);
      },
      error: Number(localBuildingSquareData) === 0
    }))))));
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const SubmeterAllocationInternal = () => {
    const measureUnitsMap = {
      water: ['Gal', 'HCF', 'Kgal', 'CGL']
    };
    const _Object$keys$filter = Object.keys(measureUnitsMap).filter(k => utility.name.toString().toLowerCase().includes(k.toLowerCase())),
      _Object$keys$filter2 = _slicedToArray(_Object$keys$filter, 1),
      filterByUtility = _Object$keys$filter2[0];
    const filteredMap = filterByUtility ? measureUnitsMap[filterByUtility] : [];
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t('add_new_property_flow.unit_of_measure'))), /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      rowSpacing: 24,
      columnSpacing: 10
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(SelectMenu, {
      id: "unit-of-measure-selector",
      value: unitOfMeasure || filteredMap[0] || null,
      label: "Unit of measure",
      labelId: "unit-of-measure-selector-label",
      onChange: handleUnitOfMeasureChange
    }, filteredMap.map(measureUnit => {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: measureUnit,
        key: measureUnit.toLowerCase()
      }, measureUnit);
    }))))));
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      onClick: () => {
        setModalState(true);
      },
      'custom-attribute': '156-allocation-method-modal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('general.edit'))),
    disabledTrigger: disabledTrigger,
    title: modalTitle,
    subTitle: modalSubTitle,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      disabled: isRubsBilling && allocationMethod === ALLOCATION_METHOD.BySubmeter || (allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage || allocationMethod === ALLOCATION_METHOD.BySquareFootage) && Number(localBuildingSquareData) === 0,
      onClick: e => {
        e === null || e === void 0 || e.preventDefault();
        setInitAllocationMethod(allocationMethod);
        setInitSqFootage(localBuildingSquareData);
        setUtilityAllocationMethod(allocationMethod);
        onSaveAndClose([{
          values: [{
            key: 'allocationMethod',
            value: allocationMethod
          }],
          utility
        }]);
        setParentBuildingSquareFootageLocal(localBuildingSquareData);
        setModalState(false);
      },
      'custom-attribute': '157-allocation-method-modal'
    }, t('add_new_property_flow.save_and_close')),
    noLeftButton: true,
    variant: "staticHeightLarge",
    transparentBackdrop: !isEdit,
    isOpen: modalState,
    handleOpen: () => setModalState(true),
    handleClose: () => {
      setAllocationMethod(initAllocationMethod);
      setLocalBuildingSquareData(initSqFootage);
      setParentBuildingSquareFootageLocal(initSqFootage);
      setModalState(false);
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.allocation_method_by')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: allocationMethod,
    onChange: handleAllocationMethodChange,
    exclusive: true,
    orientation: "vertical",
    fullWidth: true,
    className: classes.allocationMethodGroup
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.ByOccupancy
  }, t('general.occupancy')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.BySquareFootage
  }, t('general.square_footage')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.ByUnit
  }, t('general.unit')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.ByPercentageShare
  }, t('By Percentage Share')), !isRubsBilling && store.account.featureFlagsStore.getIsSubmeterInterimSolutionEnabled ? /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.BySubmeter
  }, t('general.by_submeter')) : null, /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.By50Occupancy50SquareFootage
  }, t('By 50%Occupancy/50%Square Footage')), store.company.companyFeatureStore.enableAllocationByNumberOfOccupants ? /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.ByNumberOfOccupants
  }, t('add_new_property_flow.allocation_method_number_of_occupants')) : null)), (allocationMethod === ALLOCATION_METHOD.BySquareFootage || allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && /*#__PURE__*/React.createElement(BuildingSquareInternal, {
    isBySquareFootage: allocationMethod === ALLOCATION_METHOD.BySquareFootage
  }), allocationMethod === ALLOCATION_METHOD.ByOccupancy && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.allocation_method_hint'))), allocationMethod === ALLOCATION_METHOD.ByNumberOfOccupants && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.allocation_method_number_of_occupants_hint'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(HelpCenterButton, {
    topic: "allocation method"
  })));
}